import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import styles from "./ShopExperience.module.scss";
import {useMediaQuery} from "react-responsive";
import {Exponea} from "../../../../tracking/exponea";

const ShopExperience: React.FC = () => {
  const {t} = useTranslation("checkout");
  const [rating, setRating] = useState<undefined | number>(undefined);
  const optionalInputRef = useRef<HTMLInputElement>(null);
  const [isShowing, setIsShowing] = useState(true);
  const isMobile = useMediaQuery({
    query: "(max-width: 480px)",
  });

  const NumberBox: React.FC<{num: number}> = ({num}) => {
    return (
      <div
        className={`${styles.numberBox} ${num === rating ? styles.clicked : ""}`}
        onClick={() => {
          setRating(num);
        }}
      >
        {num}
      </div>
    );
  };

  if (!isShowing) {
    return null;
  }

  return (
    <section className={styles.container}>
      <div className={styles.wrapper}>
        <span
          className={styles.closeIcon}
          onClick={() => {
            Exponea.trackClose("NPS _ Bestellabschlussseite");
            setIsShowing(false);
          }}
        />
        <div className={styles.title}>
          {t("Wie wahrscheinlich ist es, dass Sie den Einkauf bei Connox einem Freund oder Kollegen weiterempfehlen?")}
        </div>
        <div className={styles.numbersWrapper}>
          {Array.from({length: isMobile ? 6 : 11}).map((_: any, index) => {
            return <NumberBox key={index} num={index} />;
          })}
        </div>
        <div className={styles.textWrapper}>
          <span>{t("Sehr unwahrscheinlich")}</span>
          <div className={styles.borderBar} />
          <span>{t("Sehr wahrscheinlich")}</span>
        </div>
        {rating !== undefined && (
          <div className={styles.formWrapper}>
            <input
              type={"text"}
              className={styles.messageInput}
              placeholder={t("Ihre Nachricht an uns (optional)")}
              ref={optionalInputRef}
            />
            <button
              className={styles.submitButton}
              onClick={() => {
                Exponea.trackNPS({type: "Checkout", rating: isMobile ? (rating * 2) : rating, feedback: optionalInputRef.current?.value ?? ""});
                setIsShowing(false);
              }}
            >
              {t("Bewertung senden")}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ShopExperience;
